import { Fragment, useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { signOutStart } from '../../store/user/user.action';
import { clearAllCartItems } from '../../store/cart/cart.action';
import './navigation-new.css';
import logo from '../../assets/logo/ahguide.png';
import CartIcon from '../Cart-icon/cart.component';
import { selectCurrentUser } from '../../store/user/user.selector';
import { useSelector } from 'react-redux';
import { selectIsCartOpen } from '../../store/cart/cart.selector';

import CartDropdown from '../CartDropDown/cart-dropdown.component';
import SearchNew from '../Search/search-new.component';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Helmet } from 'react-helmet-async';
import WbcsSideMenu from './wbcs-side-menu';
const NavigationNew = () => {
  const user = useSelector(selectCurrentUser);

  const isCartOpen = useSelector(selectIsCartOpen);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const signOutHandler = () => {
    dispatch(signOutStart());
    navigate('/');
    dispatch(clearAllCartItems());
  };

  const closePreviousMenu = (menu) => {
    if (menu.classList.contains('nav-open')) {
      menu.classList.remove('nav-open');
    }
  };

  const hideNavExtra = () => {
    const headerEl = document.querySelector('.main-header');
    const navMenuStudy = document.querySelector('.navigation__study');
    if(navMenuStudy.classList.contains('nav-open')){
      console.log('hit')
      headerEl.classList.add('hidden');
    }
    else {
      headerEl.classList.remove('hidden');
    }
   
    

    
  };

 const navExtraToggle=()=>{
  const headerEl = document.querySelector('.main-header');
  headerEl.classList.toggle('hidden');
 }

  const openEnglishMenu = () => {
    navExtraToggle();
    const navMenuStudy = document.querySelector('.navigation__study');
    closePreviousMenu(navMenuStudy);
    const navMenuEnglish = document.querySelector('.navigation__english');

    navMenuEnglish.classList.toggle('nav-open');
  };

  const openStudyMaterialMenu = () => {
    
    // close english sub menu if open
    const navMenuEnglish = document.querySelector('.navigation__english');
    closePreviousMenu(navMenuEnglish);
    //  close wbcs side menu if previosly open
    const wbcsSideMenu = document.querySelector('.wbcs-side-menu');
    if (wbcsSideMenu.classList.contains('sidemenu-open')) {
      wbcsSideMenu.classList.remove('sidemenu-open');
    }
    // toggle b/w wbcs menu
    const navMenuEl = document.querySelector('.navigation__study');
    navMenuEl.classList.toggle('nav-open');
    hideNavExtra();
  };

  const openSideMenu = () => {
    const wbcsEl = document.querySelector('.side__menu');
    wbcsEl.parentElement.classList.toggle('sidemenu-open');
    // wbcsEl.parentElement.parentElement.toggle('sidemenu-open');
  };

  const openMobileMenu = () => {
    const mobileNav = document.querySelector('.btn-mobile-nav');
    const headerEl = document.querySelector('.main-header');
    headerEl.classList.toggle('nav-open-mobile');
  };

  const redirectToCheckout = () => {
    const headerEl = document.querySelector('.main-header');
    if (headerEl.classList.contains('nav-open-mobile')) {
      headerEl.classList.remove('nav-open-mobile');
    }
    navigate('/checkout');
  };

  return (
    <>
      <Helmet>
        <title>
          Best WBCS Coaching Online | WBCS Exam Preparation Institute | Ahguide
        </title>
        <meta
          name="description"
          content="Ahguide provides the best coaching in birbhum for WBCS and IAS. Offering advanced education, study materials, practice and doubt solving sessions and mock tests."
        />
        <link rel="canonical" href="https://www.ahguide.in" />
      </Helmet>
      <header className="main-header">
        <h1>
          <a
            href="/"
            className="logo"
            title="AH Guide an e learning portal for wbcs aspirants"
          >
            AHGUIDE
          </a>
        </h1>
        <nav className="navigation">
          <ul>
            <li>
              <div className="navigation__study nav-close">
                <a
                  href="#"
                  className="navigation-links"
                  onClick={openStudyMaterialMenu}
                >
                  Study Materials
                </a>
                <ion-icon
                  name="caret-down-outline"
                  className="icon-nav"
                ></ion-icon>
                <div className="navigation__study-menu">
                  <ul className="navigation__sub-menu">
                    <li className="wbcs-side-menu">
                      <WbcsSideMenu />
                      <a
                        href="#"
                        className="navigation__menu-links side__menu"
                        onClick={openSideMenu}
                      >
                        Wbcs
                      </a>
                    </li>
                    <li>
                      <a
                        href="/ias-study-material"
                        className="navigation__menu-links"
                      >
                        Ias
                      </a>
                    </li>
                    <li>
                      <a
                        href="/current-affairs"
                        className="navigation__menu-links"
                      >
                        Current Affairs
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>

            <li>
              <a href="/mock-test" className="navigation-links">
                Mock Test
              </a>
            </li>
            <li>
              <div className="navigation__english nav-close">
                <a
                  href="#"
                  className="navigation-links"
                  onClick={openEnglishMenu}
                >
                  English Learning
                </a>

                <ion-icon
                  name="caret-down-outline"
                  className="icon-nav"
                ></ion-icon>
                <div className="navigation__english-menu">
                  <ul className="navigation__sub-menu">
                    <li>
                      <a
                        href="/wbcs/study-material-english-grammer"
                        className="navigation__menu-links"
                      >
                        Grammer
                      </a>
                    </li>
                    <li>
                      <a
                        href="/wbcs/study-material-english-vocabulary"
                        className="navigation__menu-links"
                      >
                        Vocabulary
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <a href="/tution-fees" className="navigation-links">
                Fees
              </a>
            </li>
          </ul>
        </nav>
        <div className="nav-extra">
          {user ? (
            <a
              onClick={signOutHandler}
              href="#"
              className="btn--signin"
              title="Logout"
            >
              Log out
            </a>
          ) : (
            <a href="/login" className="btn--signin" title="Login">
              Log in
            </a>
          )}
          <div className="cart-icon" onClick={redirectToCheckout}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 004.25 22.5h15.5a1.875 1.875 0 001.865-2.071l-1.263-12a1.875 1.875 0 00-1.865-1.679H16.5V6a4.5 4.5 0 10-9 0zM12 3a3 3 0 00-3 3v.75h6V6a3 3 0 00-3-3zm-3 8.25a3 3 0 106 0v-.75a.75.75 0 011.5 0v.75a4.5 4.5 0 11-9 0v-.75a.75.75 0 011.5 0v.75z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          {/* <CartIcon />
          {isCartOpen && <CartDropdown />} */}
        </div>
        <button class="btn-mobile-nav" onClick={openMobileMenu}>
          <ion-icon class="icon-mobile-nav" name="menu-outline"></ion-icon>
          <ion-icon class="icon-mobile-nav" name="close-outline"></ion-icon>
        </button>
      </header>

      <Outlet />
    </>
  );
};

export default NavigationNew;
